import React from 'react';
import { DefaultButton, IDropdownOption, PrimaryButton } from '@fluentui/react';
import PlanillaPartidoOficialAuxiliarForm from '../../../PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliarForm';
import { useCustomInput } from '../../../../common/custom-hooks/useCustomInput';
import CustomInputIfc from '../../../../lib/FormValidator/Form/CustomInputIfc';
import { Equipo } from '../../../../system/Equipo/Equipo';
import { PlanillaPartidoOficialAuxiliar } from '../../../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import InputField from '../../../../lib/FormValidator/Form/InputField';
import DropdownInput from '../../../../lib/FormValidator/Form/DropdownInput';
import ComboBoxInput from '../../../../lib/FormValidator/Form/ComboBoxInput';
import { omit } from 'office-ui-fabric-react';

interface IOficialAuxiliarView {
  oficialesAuxiliaresInput: CustomInputIfc;
  equipo: Equipo;
  setShowFormAuxiliar: (b: boolean) => void;
}

const OficialAuxiliarView = ({
  oficialesAuxiliaresInput,
  equipo,
  setShowFormAuxiliar,
}: IOficialAuxiliarView) => {
  // INICIO - Formulario de auxiliar
  const [planillaPartidoOficialAuxiliarForm, setPlanillaPartidoOficialAuxiliarForm] =
    React.useState<PlanillaPartidoOficialAuxiliarForm>(
      PlanillaPartidoOficialAuxiliarForm.initialize(+equipo.getId()!)
    );
  const [formIsValid, setFormIsValid] = React.useState(false);

  const nombreInput = useCustomInput(
    () => planillaPartidoOficialAuxiliarForm.getNombreInput(),
    [planillaPartidoOficialAuxiliarForm]
  );
  const apelidoInput = useCustomInput(
    () => planillaPartidoOficialAuxiliarForm.getApellidoInput(),
    [planillaPartidoOficialAuxiliarForm]
  );
  const dniInput = useCustomInput(
    () => planillaPartidoOficialAuxiliarForm.getDniInput(),
    [planillaPartidoOficialAuxiliarForm]
  );
  const ordenInput = useCustomInput(
    () => planillaPartidoOficialAuxiliarForm.getOrdenInput(),
    [planillaPartidoOficialAuxiliarForm]
  );

  const onBlurCustomInput = (customInput: CustomInputIfc) => {
    setFormIsValid(planillaPartidoOficialAuxiliarForm.isValid());
  };

  // FIN - Formulario de auxiliar

  const saveAuxiliar = () => {
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    oficialesAuxiliares.push(planillaPartidoOficialAuxiliarForm.toPlanillaPartidoOficialAuxiliar());
    oficialesAuxiliaresInput.setValue(oficialesAuxiliares);
    cancelAuxiliar();
  };

  const cancelAuxiliar = () => {
    setShowFormAuxiliar(false);
    setPlanillaPartidoOficialAuxiliarForm(PlanillaPartidoOficialAuxiliarForm.initialize(+equipo.getId()!));
  };

  const getOrdenesDisponibles = () => {
    const possibleOrden = ['B', 'C', 'D'];
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    const oficialesAuxiliaresTeamOrdenes = oficialesAuxiliares
      .filter((o) => +o.getEqid() === +equipo.getId()!)
      .map((o) => o.getOrden());
    return possibleOrden
      .filter((po) => !oficialesAuxiliaresTeamOrdenes.includes(po))
      .map((o) => {
        return {
          key: o,
          text: o,
        };
      });
  };

  return (
    <>
      <div className="ms-Grid-row  mt-2">
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={apelidoInput}
            label="Apellido"
            onBlur={(input) => {
              onBlurCustomInput(input);
            }}
          />
        </div>
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={nombreInput}
            label="Nombre"
            onBlur={(input) => {
              onBlurCustomInput(input);
            }}
          />
        </div>
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={dniInput}
            label="DNI"
            onBlur={(input) => {
              onBlurCustomInput(input);
            }}
          />
        </div>
        <div className="ms-Grid-col ms-sm1">
          <ComboBoxInput
            input={ordenInput}
            onBlur={(input) => {
              onBlurCustomInput(input);
            }}
            label={'Orden'}
            options={getOrdenesDisponibles()}
          ></ComboBoxInput>
        </div>

        <div className="ms-Grid-col ms-sm5" style={{ marginTop: 28 }}>
          <PrimaryButton disabled={!formIsValid} onClick={saveAuxiliar} iconProps={{ iconName: 'Save' }}>
            Guardar
          </PrimaryButton>
          <DefaultButton
            style={{ marginLeft: 10 }}
            onClick={() => {
              cancelAuxiliar();
            }}
            iconProps={{ iconName: 'Cancel' }}
          >
            Cancelar
          </DefaultButton>
        </div>
      </div>
    </>
  );
};
export default OficialAuxiliarView;
